import React from "react";

import {
  Box,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { primaryColor } from "../../../theme";
import SearchIcon from "@mui/icons-material/Search";
import { SortableTableCell } from "../SkillMappings/SkillDetails";
const ErrorReport = ({ updatedData }) => {
  const data = updatedData
    ?.filter((item) => item.API_STATUS === "ERROR")
    .map((item) => {
      return {
        ...item,
        CREATED_DT: new Date(item.CREATED_DT).toLocaleString(),
        ACTION: item.API_OPERATION === "LOCK" ? "Locked" : "Unlocked",
      };
    });
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortOrder, setSortOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("CREATED_DT");

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const sortedData = () =>
    data
      ? data.sort((a, b) => {
          const order = sortOrder === "asc" ? 1 : -1;
          let aValue =
            orderBy === "CREATED_DT" ? new Date(a[orderBy]) : a[orderBy];
          let bValue =
            orderBy === "CREATED_DT" ? new Date(b[orderBy]) : b[orderBy];
          if (
            (aValue === null || aValue === undefined) &&
            (bValue === null || bValue === undefined)
          ) {
            return 1;
          }
          if (aValue === null || aValue === undefined) {
            return order;
          }
          if (bValue === null || bValue === undefined) {
            return -order;
          }

          if (aValue < bValue) {
            return -1 * order;
          }
          if (aValue > bValue) {
            return 1 * order;
          }
          return 0;
        })
      : [];
  const handleSortClick = (property) => {
    const isAsc = orderBy === property && sortOrder === "asc";
    setSortOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const filteredData = () => {
    if (searchTerm) {
      return sortedData().filter((row) => {
        return Object.keys(row).some((key) =>
          row[key].toString().toLowerCase().includes(searchTerm.toLowerCase())
        );
      });
    } else {
      return sortedData();
    }
  };
  const filteredDataList = filteredData();
  return (
    <Box
      sx={{
        m: 3,
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: "100%",
          gap: 6,
        }}
      >
        <Box>
          <Typography variant="body2" component={"div"}>
            FILTER CONTENT
          </Typography>
          <TextField
            size="small"
            margin="normal"
            fullWidth
            sx={{
              padding: 0,
              margin: 0,
              width: "400px",
              minWidth: 200,
            }}
            id="search"
            name="search"
            autoComplete="off"
            placeholder="Search..."
            value={searchTerm}
            onChange={handleSearchChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon style={{ color: primaryColor }} />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>
      <TableContainer>
        <Box
          sx={{
            maxHeight: "40vh",
            overflow: "auto",
            ml: 2,
            mr: 2,
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <SortableTableCell
                  property="CREATED_DT"
                  orderBy={orderBy}
                  sortOrder={sortOrder}
                  onClick={handleSortClick}
                  active={orderBy === "CREATED_DT"}
                >
                  DATE
                </SortableTableCell>
                <SortableTableCell
                  property="API_STATUS"
                  orderBy={orderBy}
                  sortOrder={sortOrder}
                  onClick={handleSortClick}
                  active={orderBy === "API_STATUS"}
                >
                  ERROR TYPE
                </SortableTableCell>
                <SortableTableCell
                  property="API_ERROR_MSG"
                  orderBy={orderBy}
                  sortOrder={sortOrder}
                  onClick={handleSortClick}
                  active={orderBy === "API_ERROR_MSG"}
                >
                  ERROR MESSAGE
                </SortableTableCell>
              </TableRow>
            </TableHead>
            <TableBody key={filteredDataList.length}>
              {filteredDataList?.map((row) => (
                <TableRow>
                  <TableCell>{row.CREATED_DT}</TableCell>
                  <TableCell>{row.API_STATUS}</TableCell>
                  <TableCell>{row.API_ERROR_MSG}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </TableContainer>
    </Box>
  );
};

export default ErrorReport;
